import HeaderBack from "../../../components/backoffice/headerback/HeaderBack";
import React, { useEffect, useState } from "react";
import { Form, Button, Dropdown, Table } from "react-bootstrap";
import {
  fetchSrStatics,
  fetchGenerateData,
  fetchSignedData,
  fetchInvoicedData,
  getBackSiteid,
  fetchSrGeneratedStatics,
  fetchSrSignedStatics,
  fetchSrInvoicedStatics,
} from "../../../modules/serverCall";
import "./stylesheets/srStatics.css";
import moment from "moment"; // Import moment.js
import Spinner from "react-bootstrap/Spinner";

const SrStatics = () => {
  // State management
  const [selectedSite, setSelectedSite] = useState("");
  const [siteId, setSiteId] = useState(null);
  const [listSiteId, setListSiteId] = useState([]);
  const [selectedOption, setSelectedOption] = useState("option1"); // State for radio button selection
  const [srDetails, setSrDetails] = useState([]);
  const [loadingData, setLoadingData] = useState(false);

  const handleDropdownSite = (key, event) => {
    const selectedValue = event.target.innerHTML;
    if (selectedValue === "All") {
      // Set siteId to a comma-separated string of all site IDs
      const allSiteIds = listSiteId.map((item) => item.key).join(",");
      setSelectedSite("All");
      setSiteId(allSiteIds);
      setSrDetails([]);
    } else {
      setSelectedSite(selectedValue);
      setSiteId(key);
      setSrDetails([]);
    }
  };

  const handleInputFetch = async () => {
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;

    const sendData = {
      siteId: siteId,
    };

    // Set loading state to true when the fetch starts
    setLoadingData(true);

    try {
      // Fetch data based on the selected radio button option
      let response;
      switch (selectedOption) {
        case "option1":
          response = await fetchSrStatics(sendData); // API call for "Jobs not part of SR"
          break;
        case "option2":
          response = await fetchSrGeneratedStatics(sendData); // API call for "Generate"
          break;
        case "option3":
          response = await fetchSrSignedStatics(sendData); // API call for "Signed"
          break;
        case "option4":
          response = await fetchSrInvoicedStatics(sendData); // API call for "Invoiced"
          break;
        default:
          response = [];
      }

      // Set the fetched data to the state
      setSrDetails(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle any errors that occur during the fetch
    } finally {
      // Set loading state to false after the fetch completes, regardless of success or failure
      setLoadingData(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;

    const fetchSiteId = async () => {
      const sendData = { userid: userId };
      const responsesites = await getBackSiteid(sendData);
      const siteIdArr = responsesites.map((site) => ({
        key: site.SiteID,
        value: site.SiteName,
      }));

      setListSiteId(siteIdArr);
      if (siteIdArr.length > 0) {
        setSelectedSite(siteIdArr[0].value);
        setSiteId(siteIdArr[0].key);
      }
    };

    fetchSiteId();
  }, []);

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
    setSrDetails([]); // Clear previous data when changing option
  };

  const renderTable = () => {
    // Table headers mapping for each radio option
    const tableHeadersMapping = {
      option1: [
        { label: "Job ID", field: "JobID" },
        { label: "Customer", field: "CustomerName" },
        { label: "Job Type", field: "JobType" },
        { label: "Technicians", field: "TechNames" },
        { label: "Job Dates", field: "JobDates" },
      ],
      option2: [
        { label: "SR#", field: "SRID" },
        { label: "SR Date", field: "SRDate" },
        { label: "Customer", field: "CustomerName" },
        { label: "SR Generated On", field: "ModifiedDate" },
        { label: "SR Job No.", field: "JobSRIds" },
      ],
      option3: [
        { label: "SR#", field: "SRID" },
        { label: "SR Date", field: "SRDate" },
        { label: "Customer", field: "CustomerName" },
        { label: "SR Generated On", field: "ModifiedDate" },
        { label: "SR Signed Date", field: "SignedDate" },
        { label: "SR Job No.", field: "JobSRIds" },
      ],
      option4: [
        { label: "Invoice#", field: "InvoiceID" },
        { label: "Invoice Date", field: "InvoiceDate" },
        { label: "SR#", field: "JobSRIds" },
        { label: "SR Job No.", field: "JobIds" },
      ],
    };

    // Determine which headers to use based on the selected radio button
    const headers = tableHeadersMapping[selectedOption];

    // Add the "Site" column header if "All" is selected in the dropdown
    const headersWithSite =
      selectedSite === "All"
        ? [...headers, { label: "Site", field: "SiteName" }]
        : headers;

    return (
      <div className="container">
        <div className="table-scroll">
          <Table
            bordered
            hover
            className="mt-3 container "
            style={{ fontSize: "11px" }}
          >
            <thead>
              <tr
                style={{
                  position: "sticky",
                  top: "0",
                  backgroundColor: "white",
                }}
              >
                {headersWithSite.map((header, index) => (
                  <th key={index}>{header.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {srDetails.length > 0 ? (
                srDetails.map((detail, rowIndex) => (
                  <tr key={rowIndex}>
                    {headers.map((header, colIndex) => (
                      <td key={colIndex}>
                        {/* Check if the field is 'SignedDate' or 'ModifiedDate' to format it using moment */}
                        {[
                          "SignedDate",
                          "ModifiedDate",
                          "SRDate",
                          "InvoiceDate",
                        ].includes(header.field)
                          ? moment(detail[header.field]).format("DD-MMM-YYYY")
                          : detail[header.field] || "N/A"}
                      </td>
                    ))}
                    {/* Add Site column if "All" is selected */}
                    {selectedSite === "All" && (
                      <td>{detail.SiteName || "N/A"}</td>
                    )}
                  </tr>
                ))
              ) : loadingData === true ? (
                <tr>
                  <td className="noData" colSpan={28}>
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan={headersWithSite.length} className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="count">Total Count : {srDetails.length}</div>
      </div>
    );
  };

  return (
    <div>
      <HeaderBack />
      <div className="container jobfilter mb-4 mt-4">
        <div className="headerfilter-inct">
          <div className="filterbtnsite">
            <Dropdown onSelect={handleDropdownSite}>
              <Dropdown.Toggle
                variant="warning"
                className="font_size"
                id="dropdown-basic"
              >
                {selectedSite || "Select Site"}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {listSiteId.map((item) => (
                  <Dropdown.Item
                    className="font_size"
                    key={item.key}
                    eventKey={item.key}
                  >
                    {item.value}
                  </Dropdown.Item>
                ))}
                {/* Add "All" option */}
                <Dropdown.Item className="font_size" key="all" eventKey="all">
                  All
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          {/* Horizontal radio buttons */}
          <div className="radio-buttons gap-3 mt-1 mr-2 d-flex">
            <Form.Check
              type="radio"
              label="WD no SR"
              name="group1"
              id="radio1"
              value="option1"
              checked={selectedOption === "option1"}
              onChange={handleRadioChange}
              className="mr-3 bold-label"
            />
            <Form.Check
              type="radio"
              label="SR Not Signed"
              name="group1"
              id="radio2"
              value="option2"
              checked={selectedOption === "option2"}
              onChange={handleRadioChange}
              className="mr-3 bold-label"
            />
            <Form.Check
              type="radio"
              label="Signed SR (Not Invoiced)"
              name="group1"
              id="radio3"
              value="option3"
              checked={selectedOption === "option3"}
              onChange={handleRadioChange}
              className="mr-3 bold-label"
            />
            <Form.Check
              type="radio"
              label="Invoived SR"
              name="group1"
              id="radio4"
              value="option4"
              checked={selectedOption === "option4"}
              onChange={handleRadioChange}
              className="bold-label"
            />
          </div>

          {/* Fetch button */}
          <div className="filterbtnsite">
            <Button
              variant="primary"
              onClick={handleInputFetch}
              style={{
                fontSize: "12px",
                marginLeft: "40px",
              }}
            >
              Fetch
            </Button>
          </div>
        </div>

        {/* Render the table based on selected radio option */}
        {renderTable()}
      </div>
    </div>
  );
};

export default SrStatics;
